/* Main Menu */
var $ = jQuery.noConflict();

$(function(){
    $(document).ready(function() {

		function setFilterGetParameter(paramName, paramValue, target) {
			var url = window.location.href;
			var url_parts = url.split('/');
			var page_index = url_parts.indexOf('page');

			if (page_index != -1) {
				url_parts.length = page_index;
				url = url_parts.join('/');
			}

			var hash = location.hash;
			url = url.replace(hash, '');

			if (url.indexOf(paramName + "=") >= 0) {
				var prefix = url.substring(0, url.indexOf(paramName + "="));
				var suffix = url.substring(url.indexOf(paramName + "="));
				suffix = suffix.substring(suffix.indexOf("=") + 1);
				suffix = suffix.indexOf("&") >= 0 ? suffix.substring(suffix.indexOf("&")) : "";
				url = prefix + paramName + "=" + paramValue + suffix;
			} else {
				if (url.indexOf("?") < 0) {
					url += "?" + paramName + "=" + paramValue;
				} else {
					url += "&" + paramName + "=" + paramValue;
				}
			}
			if (hash == '') {
				window.location.href = htmlDecode(url) + hash + target;
			} else {
				window.location.href = htmlDecode(url) + hash;
			}
		}

		function htmlDecode(value) {
			return jQuery("<textarea/>").html(value).text();
		}
	
		////////////////////////////////////////////////
        // START - hide nav on scroll down and show on scroll up
        $(function(){
            var lastScrollTop = 0, delta = 5;
            $(window).on('scroll', function(){
                var nowScrollTop = $(this).scrollTop();
                if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
                    if (nowScrollTop > lastScrollTop){
                        $('.header').addClass('header-hide');
                        $('.header').removeClass('header-show');
                        $('html,body').addClass('header-hide');
                        $('html,body').removeClass('header-show');
                    } else {
                        $('.header').removeClass('header-hide');
                        $('.header').addClass('header-show');
                        $('html,body').removeClass('header-hide');
                        $('html,body').addClass('header-show');
                   }
                lastScrollTop = nowScrollTop;
                }
            });
        });
        // END - hide nav on scroll down and show on scroll up
        ///////////////////////////////////////////////

		/////////////////////////////////////////////////////
        // START - show and hide site search desktop
        $('.site-search-toggle').on('click', function() {
			$(this).toggleClass('is-active');
			$('.site-search-box').toggleClass('is-active');
            $('body').toggleClass('site-search-box-is-active');
            // auto focus input
            $('#site-search-input').focus();
			$('.nav-wrapper').removeClass('is-active');
            // hide tooltip if search is closed via toggle button
            $('[data-toggle="tooltip"]').tooltip('hide');

			if ($(window).width() < 992) {
				window.scrollTo(0, 0);
			}
		});

        // close search form
        $('.site-search-btn-close').on('click', function() {
			$('.site-search-toggle').removeClass('is-active');
			$('.site-search-box').removeClass('is-active');
            $('body').removeClass('site-search-box-is-active');
		});
        // END - show and hide site search desktop
        //////////////////////////////////////////////////

        //////////////////////////////////////////////////////////////
        // START - add and remove class when group product is checked
        $('.wc-grouped-product-add-to-cart-checkbox').on('change', function() {
            if( $(this).is(":checked") ) {
                $('.woocommerce-grouped-product-list-item').removeClass("is-checked");
                $(this).closest('.woocommerce-grouped-product-list-item').addClass("is-checked");
            } else {
                $(this).closest('.woocommerce-grouped-product-list-item').removeClass("is-checked");
            }
        });
        // END - add and remove class when group product is checked
        //////////////////////////////////////////////////////////////
		
    });
});

"use strict";

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - Add and remove small navigation

function navigationType(scrollPos) {
	let mainHeader = document.getElementById("main-header")
	
	if (scrollPos > 196) {
		mainHeader.classList.add("small-navigation")
	} else if (scrollPos < 90) {
		mainHeader.classList.remove("small-navigation")
	}
}

jQuery(document.body).on('wc_cart_emptied', function () {
	/*--------------------------------------------------------------
	# Custom scripts for Category Feed block
	--------------------------------------------------------------*/
	const catSlider = document.querySelectorAll('.cat-feed-block .swiper');
	const catSliderNext = document.querySelectorAll('.cat-swiper-next');
	const catSliderPrev = document.querySelectorAll('.cat-swiper-prev');
	for (i = 0; i < catSlider.length; i++) {
		// loop through every example of the card slider and add a dynamic class
		// then init slider and nav arrows based on that new dynamic class
		catSlider[i].classList.add('swiper-' + i);
		catSliderNext[i].classList.add('cat-swiper-next-' + i);
		catSliderPrev[i].classList.add('cat-swiper-prev-' + i);
		var initcatSlider = new Swiper('.cat-feed-block .swiper-' + i, {
			preventClicks: false, // needed to make links in cards clickable
			preventClicksPropagation: false, // needed to make links in cards clickable
			preventInteractionOnTransition: true,
			slidesPerView: 1,
			spaceBetween: 24,
			breakpoints: {
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3, // how many to slide at a time
				}
			},
			// Navigation arrows
			navigation: {
				nextEl: '.cat-swiper-next-' + i,
				prevEl: '.cat-swiper-prev-' + i,
			}
		});
	}
});

document.addEventListener('scroll', (e) => {
	let lastKnownScrollPosition = 0
	lastKnownScrollPosition = window.scrollY
	navigationType(lastKnownScrollPosition)
})

// END - Add and remove small navigation
////////////////////////////////////////////////

////////////////////////////////////////////////
// Swiper-examples START - swiper-basic

const swiperBasic = new Swiper('.swiper-basic', {
    // Optional parameters
    // centeredSlides: true,
    // direction: 'vertical',
    // loop: true,
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 24,

    breakpoints: {
        1200: {
          slidesPerView: 4,
        },
    },

	// autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },

    // If we need pagination
    // pagination: {
    //     el: '.swiper-pagination',
    //     clickable: true,
    // //   type: "fraction",
    // //   type: "progressbar",
    // },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-prev',
        prevEl: '.swiper-next',
    },

    // And if we need scrollbar
    // scrollbar: {
    //     el: '.swiper-scrollbar-1',
    //     draggable: true,
    // },

    // Works with keyboard arrows
    keyboard: {
        enabled: true,
    },
});

var swiperStop = document.querySelector('.swiper-stop');

if (swiperStop) { 
	swiperStop.addEventListener( 'click' , function() {
		swiperBasic.autoplay.stop();
	});
}

var swiperPlay = document.querySelector('.swiper-play');

if (swiperPlay) {
	swiperPlay.addEventListener( 'click' , function() {
		swiperBasic.autoplay.start();
	});
}

// Swiper-examples END - Swiper basic
////////////////////////////////////////////////

////////////////////////////////////////////////
// Move the element with id="wcc-switcher-style-03" between the mobile and desktop <li> elements based on the viewport width,
// to avoid having duplicate ids in the HTML code.

function moveElement() {
    var viewportWidth = window.innerWidth;
    var elementToMove = document.getElementById("wcc-switcher-style-03");
    var liElement = document.querySelector(".desk-currency");
    var mobCurrency = document.querySelector(".mob-currency");

    if (!elementToMove) {
        // Element to move does not exist; exit function
        return;
    }

    if (viewportWidth > 991) {
        if (liElement) {
            liElement.appendChild(elementToMove);
        }
    } else if (mobCurrency) {
        mobCurrency.appendChild(elementToMove);
    }
}

window.addEventListener("resize", moveElement);
moveElement(); // Move the element on page load

// End Move the element with id="wcc-switcher-style-03"
////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
// Start remove parentesis and (Default) form the currency plugin 


window.addEventListener("load", function() {
    var nameElements = document.querySelectorAll(".wcc-name");
    var symbolElements = document.querySelectorAll(".wcc-symbol");
    var deskCurrency = document.querySelector('.desk-currency');

    if (nameElements.length > 0) {
        for (var i = 0; i < nameElements.length; i++) {
            nameElements[i].textContent = nameElements[i].textContent.replace(/\(Default\)/g, '').replace(/[()]/g, '');
        }
    }

    if (symbolElements.length > 0) {
        for (var i = 0; i < symbolElements.length; i++) {
            symbolElements[i].textContent = symbolElements[i].textContent.replace(/[()]/g, '');
        }
    }

    // Make .desk-currency visible to avoid jumps when Default word is removed
    if (deskCurrency) {
        deskCurrency.style.visibility = 'visible';
    }
});

// Start remove parentesis and (Default) form the currency plugin 
/////////////////////////////////////////////////////////////////


///////////////////////////////////////////////////////////////
// Start make the currency plugin accessible via keyboard

const currentCurrency = document.querySelector('.wcc-crnt-currency');

if (currentCurrency) {
    // Add the necessary attributes to make it focusable and clickable
    currentCurrency.setAttribute('role', 'button');
    currentCurrency.setAttribute('aria-pressed', 'false');
    currentCurrency.setAttribute('tabindex', '0');

    const currencyList = document.querySelector('.wcc-list');
    if (currencyList) {
        // Add the necessary attributes to make it focusable
        currencyList.setAttribute('role', 'listbox');

        const currencyListItems = currencyList.querySelectorAll('li');

        // Add the necessary attributes to make the list items focusable and clickable
        currencyListItems.forEach((item) => {
            item.setAttribute('role', 'option');
            item.setAttribute('tabindex', '0');
        });

        // Add event listeners to the list items
        currencyListItems.forEach((item) => {
            item.addEventListener('keydown', (event) => {
                // Check if the user pressed the enter key
                if (event.key === 'Enter') {
                    // Simulate a click on the list item
                    item.click();
                    // Prevent the default action of the enter key (submitting a form, for example)
                    event.preventDefault();
                }
            });
        });
    }

    // Add an event listener to the current currency element
    currentCurrency.addEventListener('keydown', (event) => {
        // Check if the user pressed the enter key
        if (event.key === 'Enter') {
            // Simulate a click on the current currency element
            currentCurrency.click();
            // Prevent the default action of the enter key (submitting a form, for example)
            event.preventDefault();
        }
    });
}


// End make the currency plugin accessible via keyboard
//////////////////////////////////////////////////////////////